import { User } from '../../models/data';

export enum AuthStatus {
  IDLE = 'idle',
  AUTHENTICATING = 'authenticating',
  AUTHENTICATED = 'authenticated',
  UNAUTHENTICATING = 'unauthenticating',
  UNAUTHENTICATED = 'unauthenticated',
}

export interface AuthState {
  status: AuthStatus;
  currentUser: User | null;
  token: string | null;
  loading: boolean;
  error: string | null;
}
